import { apiInstances } from '../../../../libs';

const { get } = apiInstances.routesInstance;

export default async function getRouteWareclouds() {
  return await get('/clouders/wareclouds/ready-to-deliver');
}
